import React from "react";
import styles from "../drabrunadonaire/sobremim_drabrunadonaire.module.scss";
import { ArrowLeft } from "lucide-react";
import WhatsappIcon from "../../icons/whatsappIcon.tsx";
import MapsIcon from "../../icons/mapsIcon.tsx";
import InstagramIcon from "../../icons/instagramIcon.tsx";
import { Link } from "react-router-dom";

const Sobremim_drabrunadonaire: React.FC = () => {
    return (
        <div className={styles.sobremim_drabrunadonaire}>
            {/* Header */}
            <div className={styles.header}>
                <Link to="/drabrunadonaire" className={styles.backButton}>
                    <ArrowLeft />
                </Link>
                <h1>Sobre mim</h1>
            </div>

            {/* Conteúdo */}
            <div className={styles.content}>
                <p>
                    Meu nome é <strong>Bruna</strong>, sou mãe de dois meninos, médica
                    ginecologista e obstetra.
                </p>

                <p>
                    Concluí medicina em Alfenas em 2017, onde estudei por seis anos.
                    Posteriormente, mudei-me para Brasília, onde realizei a residência em
                    Ginecologia e Obstetrícia na Secretaria de Saúde do Distrito Federal (HRC),
                    durante três anos.
                </p>

                <p>
                    Em 2021, segui para São Paulo, onde me aprofundei em{" "}
                    <strong>Patologia do Trato Genital Inferior</strong> pela UNIFESP. Atualmente,
                    sou pós-graduanda em <strong>Ginecologia Endócrina</strong> pelo Hospital
                    Sírio-Libanês e, em 2025, finalizei o fellowship em{" "}
                    <strong>Cirurgia Íntima</strong> pela ABGREF.
                </p>

                <p>
                    Meu foco é cuidar da saúde da mulher em todas as fases da vida: da primeira
                    menstruação à menopausa.
                </p>

                <p>
                    E meu propósito é entregar <strong>acolhimento, excelência e cuidado</strong>,
                    fortalecendo a autonomia e o protagonismo da mulher.
                </p>

                <p>
                    Sou idealizadora e fundadora do{" "}
                    <strong>Centro Médico Dona Vitta</strong>, em Barretos.
                </p>
            </div>

            {/* Footer */}
            <div className={styles.footer}>
                <p className={styles.footerTitle}>
                    Dra. Bruna Donaire • Ginecologia e Obstetrícia
                </p>
                <p className={styles.footerSubtitle}>Seja Dona • Seja Vitta</p>

                <div className={styles.footerLinks}>
                    <a
                        href="https://www.instagram.com/drabrunadonaire?igsh=MWM2ZGVmbmF3OXI0bQ=="
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <InstagramIcon color="#456345" height="28" />
                    </a>
                    <a
                        href="https://maps.app.goo.gl/i5ygw1tv3QZEUeq88"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <MapsIcon color="#456345" height="36" />
                    </a>
                </div>
            </div>

            {/* Botão WhatsApp flutuante */}
            <a
                href="https://wa.me/5517981360002?text=Olá! Vim pelo seu cartão digital e gostaria de agendar uma consulta na Dona Vitta"
                className={styles.whatsappFloat}
                target="_blank"
                rel="noopener noreferrer"
            >
                <WhatsappIcon color="#fff" />
            </a>
        </div>
    );
};

export default Sobremim_drabrunadonaire;
